const headersMutations = {
	SET_VALUES_EGGS_FOUND: 'SET_VALUES_EGGS_FOUND'
};

export default Object.freeze({
	...headersMutations,
});
